<template>
  <div class="text-justify">
    <p class="font-italic">En vigueur au 31 mars 2025.</p>

    <div data-title="Article 1. Définitions">
      <div class="text-h5 mb-2">Article 1. Définitions</div>
      <p>Au titre des présentes conditions générales d’utilisation (ci-après les « Conditions
        Générales »), les termes suivants, employés en lettre majuscule, tant au singulier
        qu’au pluriel, auront la signification suivante :</p>
      <ul>
        <li>
          <strong>Site</strong> ou <strong>Site Internet</strong> désigne le système informatique édité et exploité par
          la Société accessible en ligne à partir d’un navigateur Internet à l’adresse <a
            href="https://check-position.com"
            target="_blank">https://check-position.com</a>
          ou toutes autres adresses qui pourraient lui être substituées, permettant aux Utilisateurs d’accéder aux
          Services de l’outil Check Position.
        </li>
        <li>
          <strong>Société</strong> désigne la société MHR CONSULT, société par actions simplifiée au capital de
          1.000 €, ayant son siège social route de 14 rue de Thionville (75019) PARIS, immatriculée au
          registre du commerce et des sociétés de PARIS sous le numéro 949 729 347, éditeur et
          propriétaire du Site.
        </li>
        <li>
          <strong>Services</strong> désigne l’ensemble des services disponibles par le biais du Site Internet,
          comprenant notamment la possibilité pour l’Utilisateur d’accéder, d’utiliser et de paramétrer l’outil Check
          Position.
        </li>
        <li>
          <strong>Utilisateur</strong> désigne toute personne physique ou morale disposant d’un Compte utilisateur et
          bénéficiant d’un accès aux services proposés sur le Site Internet pour ses besoins propres ou pour les besoins
          de Bénéficiaires.
        </li>
        <li>
          <strong>Bénéficiaire</strong> désigne la personne morale ou physique pour le compte de laquelle est réalisé le
          suivi des positions Google, soit directement, soit par l’intermédiaire d’un Utilisateur du Site auquel il aura
          confié cette prestation.
        </li>
        <li>
          <strong>Compte utilisateur</strong> : interface d’administration à accès réservé à l’Utilisateur ayant
          souscrit une formule lui permettant d’utiliser les Services offerts par le Site.
        </li>
        <li><strong>Identifiants</strong> et mot de passe désigne l’ensemble des informations nécessaires à
          l’identification d’un Utilisateur sur le Site pour lui permettre d’accéder à son Compte utilisateur et de
          bénéficier des Services proposés sur le Site.
        </li>
        <li>
          <strong>Contrat</strong> désigne l’ensemble des documents liant l'entreprise MHR Consult et l’Utilisateur
          fixant les modalités et conditions d’utilisation du Site Internet, de son Contenu et des Services associés
          constitués par les présentes Conditions Générales, les Mentions légales et la Charte d’utilisation des données
          personnelles accessibles sur le Site Internet https://check-position.com .
        </li>
        <li>
          <strong>Contenu</strong> désigne les informations, données, textes, logiciels, graphiques, photographies,
          images animées, vidéos, documents téléchargeables, simulateurs, interfaces ou tous les autres documents le
          composant accessibles sur le Site Internet https://check-position.com et ce qui est susceptible d’être mis en
          ligne par un Utilisateur et accessible sur le Site.
        </li>
        <li>
          <strong>Données</strong> désignent l’ensemble des fichiers informatiques sous un format normalisé et ordonné
          destinés à être transmis par voie électronique, permettant une lecture et un traitement automatique par
          ordinateur et susceptibles d’être présentés sous une forme lisible par l’homme.
        </li>
        <li>
          <strong>Données des Utilisateurs</strong> désignent les données relatives à la navigation des Utilisateurs
          accédant au Site et les données que doit fournir l’Utilisateur pour accéder aux Services afin de permettre son
          identification.
        </li>
        <li>
          <strong>Base de données</strong> désigne un ensemble structuré et organisé permettant le stockage
          d’informations afin d’en faciliter l’exploitation (ajout, mise à jour, recherche de données, classification).
        </li>
        <li>
          <strong>Equipement(s)</strong> désigne toutes les installations techniques, sous la responsabilité de
          l’Utilisateur lui permettant de se connecter au réseau Internet et d’accéder au Site Internet <a
            href="https://check-position.com" target="_blank">https://check-position.com</a> en vue de bénéficier des
          Services.
        </li>
      </ul>
    </div>

    <div data-title="Article 2. Objet">
      <div class="text-h5 mb-2">Article 2. Objet</div>
      <p>Les présentes Conditions Générales ont pour objet de définir et préciser les termes et les conditions dans
        lesquels la Société autorise l’Utilisateur à accéder au Site et à son Contenu en vue de bénéficier des Services
        qui y sont proposés.</p>
      <p>L’accès au Site et aux Services est réservé aux Utilisateurs ayant pris connaissance des présentes conditions
        générales dans leur intégralité et les ayant acceptées expressément et sans réserve.</p>
    </div>

    <div data-title="Article 3. Opposabilité">
      <div class="text-h5 mb-2">Article 3. Opposabilité</div>
      <p>Les présentes conditions générales s’appliquent à toute utilisation du Site et des Services associés.</p>
      <p>Le fait pour l’Utilisateur de souscrire aux Services implique automatiquement qu’il a pris pleine et entière
        connaissance des présentes Conditions Générales ainsi que des stipulations contenues dans les rubriques « Charte
        des Données personnelles » et « Mentions Légales », et sera réputé les avoir acceptées sans réserve.</p>
      <p>Par ailleurs, l’accès à certaines parties du Site ou à certains services peut être restreint et/ou leur
        utilisation soumise à des conditions additionnelles et/ou spécifiques.</p>
      <p>La Société est libre de modifier, à tout moment, les présentes Conditions Générales, afin notamment de prendre
        en compte toute évolution légale, jurisprudentielle, éditoriale et/ou technique. La version qui prévaut est
        celle validée par l’Utilisateur lors de sa dernière connexion sur le Site.</p>
      <p>Aucune condition particulière ne peut, si elle n’a pas été préalablement et expressément acceptée par la
        Société, prévaloir sur les Conditions Générales.</p>
      <p>Toute condition contraire aux Conditions Générales imposée par l’Utilisateur sera donc écartée à défaut
        d’acceptation expresse par la Société et ceci, quel que soit le moment où elle aura pu être portée à sa
        connaissance.</p>
      <p>Le fait que la Société ne se prévale pas à un moment donné de l’une quelconque des présentes Conditions
        générales d’utilisation ne peut être interprété comme valant renonciation à se prévaloir ultérieurement de l’une
        quelconque de ces conditions.</p>
    </div>

    <div data-title="Article 4. Editeur du Site">
      <div class="text-h5 mb-2">Article 4. Editeur du Site</div>
      <p>
        la société MHR CONSULT, société par actions simplifiée au capital de 1.000 €, ayant son siège social route
        de 14 rue de Thionville (75019) PARIS, immatriculée au registre du commerce et des

        sociétés de PARIS sous le numéro 949 729 347, représentée par Monsieur Michael EL-BAZ,
        dûment habilité à cet effet.
      </p>
    </div>

    <div data-title="Article 5. Descriptions des Services">
      <div class="text-h5 mb-2">Article 5. Descriptions des Services</div>
      <p>Les Services proposés sur le Site permettent à l’Utilisateur de suivre les positions de son/ses site(s)
        Internet sur Google.</p>
      <p>Le Site permet à l’Utilisateur de surveillez l’évolution quotidienne de ses positions sur Google ainsi que de
        vérifier sa position sur chaque datacenter de Google.</p>
      <p>Une recherche par mot-clé, nom de domaine, géolocalisation et langue permet à l’Utilisateur d’affiner
        l’expression de ses besoins afin d’obtenir une analyse ultra précise et en temps réel de la position de son ou
        ses site Internet sur une liste de plusieurs datacenters de Google.</p>
      <p>Les positions varient selon le datacenter sur lequel l’Utilisateur navigue et chaque recherche permet alors à
        l’Utilisateur d’identifier avec précision la position réelle de son site Internet et celle de ses concurrents
        par datacenters.</p>
      <p>Le Site permet également à l’Utilisateur de suivre quotidiennement ses positions dont les variations sont
        consultables chaque matin, et d’actualiser toutes ses positions plusieurs fois par jour.</p>
      <p>Une fois les critères de recherche définis et la vérification lancée, les résultats sont directement visibles
        sur l’outil Check Position et l’Utilisateur peut suivre facilement et rapidement les positions de son ou ses
        sites Internet à l’aide d’une interface ergonomique et optimisée également disponible sur mobile.</p>
      <p>Après avoir consulté les résultats affichés, l’Utilisateur pourra les exploiter pour son propre compte ou les
        transmettre au Bénéficiaire.</p>
      <p>Le Site permet en outre à l’Utilisateur de conserver un historique de toutes ses vérifications.</p>
      <p>L’Utilisateur pourra également importer ses mots-clés et historiques à partir d'autres plateformes pour ne
        perdre aucune donnée.</p>
      <p>Par ailleurs, l’Utilisateur est seul responsable du respect des limites techniques et/ou juridiques imposées
        par l’éditeur du site Google.</p>
      <p>Sauf stipulation contraire, toute nouvelle caractéristique qui améliore ou augmente un ou plusieurs Services
        existants ou tout nouveau Service proposé sur le Site sera soumis aux présentes Conditions générales
        d’utilisation.</p>
      <p>La Société se réserve le droit de modifier à tout moment et/ou de compléter les Services disponibles par
        l’intermédiaire du Site Internet.</p>
    </div>

    <div data-title="Article 6. Liens hypertextes">
      <div class="text-h5 mb-2">Article 6. Liens hypertextes</div>
      <p>Le Site peut contenir des liens renvoyant vers d’autres sites Internet, sur lesquels la Société n’a aucun
        contrôle.</p>
      <p>La Société n’est en aucun cas responsable de la sécurité des contenus et des politiques ou pratiques de
        protection des Données des autres sites visités à partir du Site.</p>
      <p>Il appartient à l’Utilisateur de prendre connaissance des politiques de protection des Données de ces autres
        sites, afin de comprendre leurs modalités de collecte, d’utilisation et de partage de ses Données.</p>
    </div>

    <div data-title="Article 7. Conditions d’utilisation du Site et des Services">
      <div class="text-h5 mb-2">Article 7. Conditions d’utilisation du Site et des Services</div>
      <p class="text-decoration-underline">7.1 Limites d’utilisation</p>
      <p>Les informations reproduites et agrégées sur le Site proviennent de sites Internet tiers. L'entreprise MHR
        Consult n’étant pas en mesure de vérifier leur exactitude et leur pertinence, celles-ci sont fournies en l’état,
        ce que l’Utilisateur reconnaît et accepte.</p>
      <p>Ces informations sont fournies dans l’unique but de permettre à l’Utilisateur d’améliorer et optimiser sa
        visibilité sur Internet en suivant ses positions sur Google et leur évolution quotidienne.</p>
      <p>Le droit d’accès et d’utilisation accordé à l’Utilisateur est non exclusif, personnel et non transférable.</p>
      <p>L’Utilisateur déclare et reconnaît avoir reçu de la Société toutes les informations et conseils nécessaires
        relatifs au Site et aux Services, notamment au titre de leurs conditions, modalités et limites de
        fonctionnement.</p>
      <p>L’Utilisateur s’engage à n’utiliser le Site et les Services que conformément à leur destination et à ne pas en
        faire une utilisation détournée.</p>
      <p>L’Utilisateur est seul responsable des Données qu’il transfère et traite par l’intermédiaire du Site et des
        Services, conformément à la règlementation en vigueur, ainsi que des résultats produits à partir de ces Données,
        et de leur utilisation.</p>
      <p class="text-decoration-underline">7.2 Vérifications des prérequis</p>
      <p>Préalablement à tout accès aux Services, les Utilisateurs devront s’assurer qu’ils disposent des conditions
        nécessaires définies ci-après afin d’accéder à l’ensemble des fonctionnalités des Services du Site.</p>
      <p class="font-italic ml-8">- 7.2.1 Conditions liées aux Utilisateurs</p>
      <p>L’accès au Site et aux Services est réservé aux personnes physiques ou morales qui ont souscrit à une des
        formules proposées sur le Site et qui disposent d’identifiants pour se connecter à leur Compte utilisateur.</p>
      <p>Le titulaire d’un Compte utilisateur s’engage à respecter et à faire respecter par les personnes placées sous
        sa responsabilité la règlementation en vigueur.</p>
      <p class="font-italic ml-8">- 7.2.2 Conditions techniques</p>
      <p>Afin de pouvoir accéder à l’intégralité des Services, les Utilisateurs doivent disposer d’un ordinateur équipé
        et configuré pour se connecter à Internet et compatible avec les fonctionnalités d’utilisation du Site et des
        Services, d’un accès Internet haut débit, des logiciels et d’une configuration permettant l’accès au Site et aux
        Services, ainsi que des versions minimums des navigateurs suivants :</p>
      <ul>
        <li>Chromium (Chrome, Edge Insider), version minimale 81.0.4032</li>
        <li>Edge, version minimale 79.0.309.65</li>
        <li>Firefox, version minimale 78.0</li>
        <li>Safari, version minimale 10</li>
      </ul>
      <p>Les Equipements permettant l’accès et l’utilisation du Service sont à la charge exclusive de l’Utilisateur, de
        même que les frais de communication électronique notamment les coûts d’accès à Internet. Il appartient à
        l’Utilisateur de s’informer du prix d’utilisation desdits Equipements auprès des opérateurs et/ou fournisseurs
        concernés.</p>
      <p>Par conséquent, l’Utilisateur supportera toutes les conséquences attachées à une configuration, un paramétrage
        ou une utilisation non conforme de ses Equipements.</p>
      <p>La Société décline toute responsabilité en cas de non-respect des conditions notamment celles exposées
        ci-dessus.</p>
    </div>

    <div data-title="Article 8. Site et des Services">
      <div class="text-h5 mb-2">Article 8. Site et des Services</div>
      <p class="text-decoration-underline">Article 8.1. Disponibilité du Site et des Services</p>
      <p>La Société s’efforce de fournir un accès permanent au Site et aux Services 24 heures sur 24, 7 jours sur 7.</p>
      <p>Toutefois, l’accès au Site et aux Services peut être suspendu, à tout moment et sans préavis, notamment du fait
        de pannes, de défaillances ou de paralysie du réseau, du système et/ou des moyens de communication, ainsi que du
        fait des interventions de maintenance et de corrections rendues nécessaires par la mise à jour et le bon
        fonctionnement du Site.</p>
      <p>
        La Société informera l’Utilisateur, dans la mesure du possible, de l’existence et de la durée de la suspension.
        La Société s’efforcera de procéder aux opérations de maintenance aux heures où le Site est le moins utilisé.
      </p>
      <p>
        Cette disposition ne s'applique pas aux cas visés à l'article 8.1 bis concernant les
        interruptions de service liées aux restrictions imposées par des services externes (Google,
        Bing, etc.) ou tout autre fait extérieur indépendant de la volonté de la Société.
        Article 8.1 bis. Limitation de responsabilité liée aux restrictions imposées par des services
        externes
        L'Utilisateur reconnaît et accepte expressément que les Services fournis par la Société sont
        essentiellement dépendants des conditions d'accès et d'utilisation de services externes
        (Google, Bing, etc.). La Société informe l'Utilisateur que ces services externes durcissent
        régulièrement leurs politiques d'accès aux données de positionnement et peuvent, à leur
        seule discrétion, limiter, bloquer ou interdire l'accès à leurs services.
        En cas d'interruption des Services due à des restrictions, blocages ou limitations imposés
        par des services externes (Google, Bing, etc.) ou tout autre fait extérieur indépendant de la
        volonté de la Société, cette dernière s'engage à mettre tout en œuvre pour rétablir les
        Services dans les meilleurs délais, sans toutefois pouvoir garantir un délai de rétablissement.
        L'Utilisateur accepte expressément que, dans de telles circonstances, la Société ne pourra
        être tenue responsable de l'interruption des Services et qu'aucun remboursement ne sera dû

        pour les périodes d'interruption (jours, semaines ou mois), et ce quelle que soit la durée de
        l'interruption.
        En cas d'impossibilité définitive d'accès aux données des services externes rendant le
        Service inaccessible de manière permanente, pour une cause extérieure à la volonté de la
        Société, l'Utilisateur accepte expressément qu'aucun remboursement ne sera dû, que ce soit
        pour les abonnements mensuels ou annuels en cours.
        L'acceptation des présentes Conditions Générales vaut reconnaissance par l'Utilisateur de
        ces risques inhérents au Service et de l'exonération de responsabilité de la Société dans ces
        circonstances spécifiques.
      </p>
      <p>L’Utilisateur s’engage à ne pas entraver l’accès au Site et aux Services et/ou le bon fonctionnement du Site de
        quelque manière que ce soit, susceptible d’endommager, d’intercepter, d’interférer avec tout ou partie du
        Site.</p>
      <p>Il est rappelé que le fait d’accéder ou de se maintenir frauduleusement dans un système informatique,
        d’entraver ou de fausser le fonctionnement d’un tel système, d’introduire ou de modifier frauduleusement des
        Données dans un système informatique constitue des délits passibles de sanctions pénales.</p>
      <p>La Société prend des précautions raisonnables pour assurer la protection matérielle du Site et des Services
        associés.</p>
      <p>Cependant, la Société ne saurait être tenue responsable des éléments en dehors de son contrôle et des dommages
        qui pourraient éventuellement être subis à l’environnement technique de l’Utilisateur et notamment ses
        Equipements et tout autre matériel utilisé pour accéder ou utiliser le Site et les Services de manière
        générale.</p>
      <p class="text-decoration-underline">Article 8.2. Maintenance et mises à jour du Site</p>
      <p>S’agissant d’une application informatique en mode « Full SaaS » installée sur les serveurs directement
        administrés par la Société, l’Utilisateur bénéficiera automatiquement de la maintenance corrective et des
        éventuelles mises à jour du Site, lesquelles ne nécessiteront pas, en principe, d’actions particulières de
        l’Utilisateur.</p>
      <p>Néanmoins, afin de maintenir un niveau optimal de services, la Société pourra à tout moment demander à
        l’Utilisateur d’effectuer d’éventuelles mises à jour de son Equipement. À défaut, l’Utilisateur sera seul
        responsable des interruptions et/ou des dégradations éventuelles des Services qui en résulteraient.</p>
      <p>En revanche et, sauf stipulation contraire, l’accès aux évolutions des Services feront l’objet d’un avenant
        afin de permettre à l’Utilisateur d’en bénéficier.</p>
    </div>

    <div data-title="Article 9.	Modalités d’inscription">
      <div class="text-h5 mb-2">Article 9. Modalités d’inscription</div>
      <p class="text-decoration-underline">9.1. Conditions d’accès</p>
      <p>Pour pouvoir accéder à l’ensemble des Services proposés sur le Site, l’Utilisateur doit obligatoirement :</p>
      <ul>
        <li>Compléter le formulaire d’inscription en ligne en renseignant les informations suivantes : nom, prénom,
          adresse électronique, nom de la structure ;
        </li>
        <li>Accepter les présentes Conditions générales d’utilisation au moyen d’une case à cocher préalablement à
          l’envoi du formulaire d’inscription ;
        </li>
        <li>Cliquer sur le lien contenu dans le mail de confirmation adressé sur l’adresse de courrier électronique
          renseignée lors de son inscription ;
        </li>
        <li>Choisir une des formules proposées sur le Site et effectuer le paiement correspondant le cas échéant.</li>
      </ul>
      <p>L’Utilisateur s’engage à fournir des données exactes et complètes qui ne portent pas atteinte, à quelque titre
        que ce soit, aux droits des tiers.</p>
      <p>L’Utilisateur s’engage à informer la Société de toute modification des informations précitées par
        l’intermédiaire de son Compte utilisateur.</p>
      <p class="text-decoration-underline">9.2 Vérifications des informations et contrôle de compatibilité </p>
      <p>La Société effectuera les vérifications nécessaires au titre des informations communiquées par l’Utilisateur
        via le formulaire d’inscription.</p>
      <p>Ces vérifications sont destinées à s’assurer que les conditions préalables sont remplies et que les
        informations recueillies au titre du formulaire sont complètes. </p>
      <p>La Société ne saurait être tenue responsable au cas où les coordonnées et informations fournies au moment de la
        souscription du contrat seraient inexactes, incomplètes ou obsolètes.</p>
      <p class="text-decoration-underline">9.3 Validation et accès aux Services</p>
      <p>Sous réserve du respect des conditions mentionnées ci-dessus, la validation du Compte utilisateur sera
        immédiate après validation de l’inscription par la Société ainsi que du paiement pour les formules payantes,
        permettant ensuite à l’Utilisateur correspondant de bénéficier immédiatement des Services souscrits.</p>
      <p>L’Utilisateur peut à tout moment modifier ses Identifiants en se rendant sur son Compte utilisateur dans
        l’onglet « Mon compte / Mon profil ».</p>
      <p class="text-decoration-underline">9.4 Reconduction et Désinscription</p>
      <p>La souscription à la formule mensuelle sera automatiquement reconduite à la fin de chaque période.</p>
      <p>L’Utilisateur ayant souscrit à la formule mensuelle n’est soumis à aucun engagement et chaque Utilisateur
        pourra à tout moment demander sa désinscription en se rendant sur la page dédiée dans son Espace personnel ou en
        contactant directement la Société par courrier électronique.</p>
      <p>La désinscription de l’Utilisateur pourra intervenir à tout moment mais ne sera effective qu’à l’issue de la
        période contractuelle de fourniture des Services, autrement dit mensuellement ou annuellement selon la formule
        souscrite par l’Utilisateur.</p>
      <p>La désinscription pourra également intervenir de manière anticipée s’agissant des Utilisateurs ayant souscrits
        à une formule annuelle, mais sans aucun droit à remboursement des sommes versées dans cette hypothèse.</p>
    </div>

    <div data-title="Article 10. Conditions financières">
      <div class="text-h5 mb-2">Article 10. Conditions financières</div>
      <p class="text-decoration-underline">10.1 Conditions financières</p>
      <p>La Société propose différentes formules pouvant être souscrites soit sous forme de forfait mensuel avec tacite
        reconduction, soit sous forme d’abonnement annuel.</p>
      <p>Les conditions financières des différentes formules proposées sont détaillées sur la page suivante : <a
          href="https://check-position.com/">https://check-position.com/</a>.</p>
      <p>Tous les tarifs sont mentionnés en euros et hors taxe (TVA à 20% en sus).</p>
      <p>Les tarifs proposés pour les abonnements pourront être modifiés ou révisés par la Société. Le changement de
        prix aura lieu à la date anniversaire de la souscription, soit à l’issue du mois ou de l’année d’abonnement en
        cours, en respectant un préavis d’un mois. Pendant le mois qui suivra cette notification, l’Utilisateur aura la
        possibilité de résilier le contrat ; faute pour lui de le faire, la modification de prix s’appliquera à la date
        prévue dans le cadre de la tacite reconduction du contrat correspondant.</p>
      <p class="text-decoration-underline">10.2 Modalités de paiement </p>
      <p>Les paiements seront effectués par avance pour chaque période contractuelle de fourniture des Services, soit
        mensuellement pour le mois à intervenir ou annuellement pour l’année souscrite.</p>
      <p>Les factures des Services souscrits sont accessibles sur le Compte utilisateur, à la rubrique « Facturation »
        et téléchargeables en format PDF.</p>
      <p>L’Utilisateur se libèrera des sommes dues soit en procédant à un règlement par carte bancaire (via Stripe) à
        partir de son Compte utilisateur, soit par virement bancaire.</p>
      <p>En cas de modification des informations de facturation, l’Utilisateur accepte et s’engage à mettre à jour
        rapidement les informations relatives à son Compte et à ses paiements, y compris son adresse électronique, son
        mode de paiement et la date d’expiration de sa carte de paiement le cas échéant.</p>
      <p class="text-decoration-underline">10.3 Retard de paiement</p>
      <p>En cas de retard de paiement, des courriers électroniques de relance seront adressés à l’Utilisateur lui
        notifiant un délai de 14 jours après lequel, à défaut de régularisation, le contrat sera résilié dans les
        conditions prévues à l’Article 19.</p>
      <p>Tout retard ou défaut de paiement par l’Utilisateur donnera lieu à une suspension automatique de son Compte
        utilisateur ainsi que de l’ensemble des Services qui lui sont attachés, dans un délai de 14 jours suivant la
        date d’échéance du paiement.</p>
    </div>

    <div data-title="Article 11. Protection des données personnelles">
      <div class="text-h5 mb-2">Article 11. Protection des données personnelles</div>
      <p class="text-decoration-underline">11.1 Collecte de données personnelles</p>
      <p class="font-italic ml-8">11.1.1 Collecte des Données de l’Utilisateur</p>
      <p>Lors de l’inscription des Utilisateurs, de l’accès et de l’utilisation des Services, la Société et ses
        partenaires techniques sont susceptibles de recueillir différentes données personnelles. La Société est le
        responsable du traitement.</p>
      <p>Chaque Utilisateur n’a accès qu’à ses propres Données et ne peut en aucun cas consulter ou obtenir les Données
        d’un autre Utilisateur. La Société s’engage à assurer une parfaite étanchéité entre les Données des différents
        Utilisateurs.</p>
      <p>Ces Données sont nécessaires pour permettre aux Utilisateurs d’accéder et d’utiliser les Services.</p>
      <p>Elles sont destinées uniquement à la Société et à ses prestataires techniques. Elles ne seront pas réutilisées
        par la Société, ni communiquées à des tiers, sauf si la loi l’impose ou l’autorise et/ou sous réserve d’un
        accord préalable et exprès des Utilisateurs.</p>
      <p>À ce titre, l’Utilisateur déclare avoir pris connaissance et accepter sans réserve les rubriques "Mentions
        Légales" et "Charte d'utilisation des données personnelles" accessibles via le site web
        https://check-position.com/, lesquelles font partie intégrante des présentes Conditions Générales d’utilisation
        des Services.</p>
      <p class="font-italic ml-8">11.1.2 Collecte et traitement des Données des Bénéficiaires</p>
      <p>L’Utilisateur sera seul responsable des informations personnelles qui lui seront communiquées par ses propres
        clients et qui pourront être saisies sur le Site en qualité de Bénéficiaire du résultat de la prestation.</p>
      <p>L’Utilisateur fera son affaire des mises en conformité de ses traitements de données personnelles au regard de
        la loi applicable et plus particulièrement du règlement n°2016/679, dit règlement général sur la protection des
        données (RGPD) entré en vigueur le 25 mai 2018.</p>
      <p>Ces Données ne pourront être réutilisées par la Société ni communiquées à des tiers, sauf si la loi l’impose ou
        l’autorise et/ou sous réserve d’un accord préalable et exprès des personnes concernées.</p>
      <p>Ces Données pourront toutefois, après avoir été anonymisées, faire l’objet de traitement à des fins
        statistiques.</p>
      <p class="text-decoration-underline">11.2 Droit d’accès et de rectification des données personnelles</p>
      <p class="font-italic ml-8">11.2.1 Données de l’Utilisateur</p>
      <p>L’Utilisateur peut librement et à tout moment modifier les informations personnelles le concernant par
        l’intermédiaire de son Compte utilisateur.</p>
      <p class="font-italic ml-8">11.2.2 Données des Bénéficiaires </p>
      <p>Conformément à la loi n°78-17 du 6 janvier 1978 modifiée et au règlement n°2016/679, dit règlement général sur
        la protection des données (RGPD), les Bénéficiaires des résultats de recherche obtenus par l’intermédiaire d’un
        Utilisateur disposent d’un droit d’accès, de modification, de rectification et de suppression des Données les
        concernant.</p>
      <p>En conséquence, l’Utilisateur s’engage à permettre et à organiser l’exercice de ces droits en conformité avec
        la législation applicable.</p>
      <p>La Société ne pourra être tenue pour responsable, notamment à l’égard des Utilisateurs et plus généralement des
        tiers, du contrôle à priori ou à posteriori de la qualité et/ou du caractère habilité ou non de la personne qui
        collecte, obtient, divulgue et transmet des informations auprès de la Société, notamment des informations à
        caractère personnel, ceci à quelque titre que ce soit et sur quelque fondement que ce soit, de même que de
        l’utilisation ou non utilisation, exploitation ou non exploitation, qui serait faite par la Société ou par un
        tiers des informations transmises.</p>
    </div>

    <div data-title="Article 12. Droit de rétractation">
      <div class="text-h5 mb-2">Article 12. Droit de rétractation</div>
      <p>Les personnes ayant la qualité de consommateur au sens du Code de la consommation bénéficient d’un droit de
        rétractation selon les modalités rappelée ci-dessous :</p>
      <p class="text-decoration-underline">Article L.221-18 du Code de la consommation :</p>
      <p class="ml-2 font-italic">"Le consommateur dispose d'un délai de quatorze jours pour exercer son droit de
        rétractation d'un contrat conclu à distance, à la suite d'un démarchage téléphonique ou hors établissement, sans
        avoir à motiver sa décision ni à supporter d'autres coûts que ceux prévus aux articles L. 221-23 à L.
        221-25. </p>
      <p class="ml-2 font-italic">Le délai mentionné au premier alinéa court à compter du jour de la conclusion du
        contrat, pour les contrats de prestation de services et ceux mentionnés à l'article L. 221-4 ".</p>
      <p>En conséquence, la fourniture de Services par la Société ne pourra intervenir qu’à l’expiration d’un délai de
        quatorze jours sauf si l’Utilisateur notifie à la Société son intention de bénéficier des Services avant la fin
        du délai de rétractation en cochant la case correspondante lors de la souscription du ou des Service(s).</p>
      <p class="text-decoration-underline">Article L.221-25 du Code de la consommation :</p>
      <p class="ml-2 font-italic">"Si le consommateur souhaite que l'exécution d'une prestation de services ou d'un
        contrat mentionné au premier alinéa de l'article L. 221-4 commence avant la fin du délai de rétractation
        mentionné à l'article L. 221-18, le professionnel recueille sa demande expresse par tout moyen pour les contrats
        conclus à distance et sur papier ou sur support durable pour les contrats conclus hors établissement.</p>
      <p class="ml-2 font-italic">Le consommateur qui a exercé son droit de rétractation d'un contrat de prestation de
        services ou d'un contrat mentionné au premier alinéa de l'article L. 221-4 dont l'exécution a commencé, à sa
        demande expresse, avant la fin du délai de rétractation verse au professionnel un montant correspondant au
        service fourni jusqu'à la communication de sa décision de se rétracter ; ce montant est proportionné au prix
        total de la prestation convenu dans le contrat. Si le prix total est excessif, le montant approprié est calculé
        sur la base de la valeur marchande de ce qui a été fourni. </p>
      <p class="ml-2 font-italic">Aucune somme n'est due par le consommateur ayant exercé son droit de rétractation si
        sa demande expresse n'a pas été recueillie en application du premier alinéa ou si le professionnel n'a pas
        respecté l'obligation d'information prévue au 4° de l'article L. 221-5".</p>
    </div>

    <div data-title="Article 13. Caractéristiques et limites du réseau Internet">
      <div class="text-h5 mb-2">Article 13. Caractéristiques et limites du réseau Internet</div>
      <p>L’Utilisateur déclare accepter les caractéristiques et les limites de l’Internet, et, en particulier, il
        reconnaît : </p>
      <ul>
        <li>Avoir connaissance de la nature du réseau Internet et, en particulier, de ses performances techniques et des
          temps de réponse pour consulter et utiliser les Services proposés,
        </li>
        <li>Que les Données circulant sur l’Internet ne sont pas nécessairement protégées, notamment contre les
          détournements éventuels,
        </li>
        <li>Que la communication par l’Utilisateur à des tiers de toute information jugée confidentielle, se fait aux
          risques et périls de l’Utilisateur,
        </li>
        <li>Qu’il appartient à l’Utilisateur de prendre toutes les mesures appropriées de façon à protéger ses Données
          de la contamination par des virus, le cas échéant, sur le réseau Internet,
        </li>
        <li>Que les Données et/ou informations circulant sur Internet peuvent être réglementées en termes d’usage ou
          être protégées par un droit de propriété.
        </li>
      </ul>
    </div>

    <div data-title="Article 14. Garantie et responsabilité de la Société">
      <div class="text-h5 mb-2">Article 14. Garantie et responsabilité de la Société</div>
      <p>
        La Société garantit que le Site et les Services proposés sont accessibles et peuvent être
        utilisés dans les conditions définies dans les présentes Conditions Générales, sous réserve
        des limitations spécifiques énoncées à l&#39;article 8.1 bis. Cette garantie est exclusive de toute
        autre garantie et notamment de résultat.
      </p>
      <p>L’Utilisateur reconnaît et accepte que le Site et les Services proposés relèvent d’un domaine particulièrement
        complexe en matière de technique informatique et qu’il ne peut matériellement pas faire, notamment dans le
        contexte de l’utilisation mutualisée de leurs fonctionnalités, l’objet de tests ni d’expériences couvrant toutes
        les possibilités d’utilisation.</p>
      <p>La Société est responsable de la bonne exécution de ses obligations contractuelles. </p>
      <p>En tout état de cause, la responsabilité de la Société pourra être engagée uniquement pour des faits prouvés et
        légalement fondés et qui lui seraient exclusivement imputables.</p>
      <p>
        La Société est responsable de la bonne exécution de ses obligations contractuelles dans la
        limite des moyens dont elle dispose et sous réserve des contraintes techniques et limitations
        imposées par des tiers, notamment des services externes (Google, Bing, etc.), dont
        dépendent ses Services.
      </p>
      <p>
        La Société ne saurait être tenue pour responsable de l&#39;inaboutissement des vérifications
        lancées par les Utilisateurs suite à leur sélection de critères de recherche ou de toute
        interruption de service résultant des cas visés à l&#39;article 8.1 bis.
      </p>
      <p>En particulier, la Société ne saurait voir sa responsabilité engagée pour : </p>
      <ul>
        <li>Le non-respect ou la mauvaise exécution par l’Utilisateur de l’une quelconque des dispositions
          contractuelles des Conditions Générales ;
        </li>
        <li>Les difficultés ou le temps d’accès au Site et notamment l’interruption temporaire ou définitive du Site et
          des Services du fait du non-respect total ou partiel d’une obligation, d’une défaillance et/ou d’une
          saturation à certaines périodes des opérateurs de réseaux de télécommunications et/ou des fournisseurs d’accès
          à Internet, et/ou des hébergeurs de l’outil Check Position et/ou des fournisseurs de solutions techniques
          utilisées par l’outil Check Position ;
        </li>
        <li>Le contenu des informations transmises et traitées et l’absence de mise à jour de ces informations ;</li>
        <li>Les erreurs de manipulation et/ou d’interprétation ;</li>
        <li>La contamination par virus des Données et/ou des logiciels des Utilisateurs, dont la protection incombe à ce
          dernier ;
        </li>
        <li>Les dommages que pourraient subir les ordinateurs et le matériel de l’Utilisateur nécessaire à l’utilisation
          du Site et des Services ou leur mauvaise utilisation, ceux-ci étant sous l’entière responsabilité de
          l’Utilisateur ;
        </li>
        <li>Les détournements éventuels de toute information à caractère sensible pour l’Utilisateur, et plus
          généralement ;
        </li>
        <li>La compatibilité de l’accès au Site et aux Services avec les équipements de l’Utilisateur ;</li>
        <li>La perte et/ou la destruction éventuelle de Données et/ou d’informations, malgré les mesures raisonnables de
          sécurité mises en place par la Société ;
        </li>
        <li>Les préjudices directs ou indirects qui ne résultent pas directement et exclusivement d’un manquement établi
          à l’encontre de la Société, notamment, sans que cette liste soit limitative, dommages immatériels, pertes de
          Données ou d’informations ou autre perte similaire ou toutes actions émanant de tiers.
        </li>
      </ul>
      <p>Dans le cas où la responsabilité de la Société serait retenue, le montant total des réparations qui pourraient
        être mis à sa charge correspondra au seul préjudice direct, personnel et certain et, en tout état de cause, sera
        limité au montant des sommes effectivement versées par l’Utilisateur au cours des 6 derniers mois.</p>
    </div>

    <div data-title="Article 15. Obligations et responsabilité de l’Utilisateur">
      <div class="text-h5 mb-2">Article 15. Obligations et responsabilité de l’Utilisateur</div>
      <p>L’Utilisateur s’engage à respecter et à faire respecter par les personnes placées sous sa responsabilité les
        caractéristiques et les limites fixées par la Société et ses partenaires techniques quant à l’utilisation des
        Services, et plus généralement l’ensemble des dispositions des présentes Conditions Générales.</p>
      <p>L’Utilisateur garantit la Société contre tout dommage, de quelque nature qu’il soit, toute réclamation ou
        action en justice émanant de ses propres clients et Bénéficiaires, relatifs à l’utilisation qu’il fait du Site
        et des Services. À ce titre, l’Utilisateur s’engage à indemniser la Société des condamnations de toute nature,
        ainsi que des indemnités, des dommages-intérêts et des honoraires d’avocat et frais de justice résultant de son
        utilisation du Site et des Services et plus généralement des engagements contractuels qu’il pourrait être amenés
        à prendre après avoir consulté le Site et/ou utilisés les Services.</p>
      <p>L’Utilisateur s’engage à n’utiliser le Site et les Services que conformément à leurs destinations. Il s’engage
        à ne pas faire une utilisation détournée du Site et des Services mis à sa disposition.</p>
      <p>L’Utilisateur est seul responsable des Données qu’il transfère et traite par l’intermédiaire du Site et des
        Services, conformément à la règlementation en vigueur, ainsi que des résultats produits à partir de ces Données,
        et de leur utilisation.</p>
      <p>L’Utilisateur reconnaît également être seul responsable de l’utilisation faite par lui du site Google ainsi que
        du respect des Conditions générales d’utilisation de Google.</p>
    </div>

    <div data-title="Article 16. Assistance">
      <div class="text-h5 mb-2">Article 16. Assistance</div>
      <p>La Société met différents moyens d’informations et de conseil à la disposition de l’Utilisateur par le biais
        notamment d’une aide contextuelle en ligne disponible sur le Site. À ce titre, l’Utilisateur s’engage à
        consulter ces moyens d’informations préalablement à toute sollicitation du service d’assistance.</p>
      <p>L’Utilisateur peut contacter la Société à tout moment par courrier électronique en utilisant le formulaire de
        contact prévu à cet effet sur le Site par ainsi que par le réseau social Twitter .</p>
      <p>Ces demandes seront traitées dans les meilleurs délais</p>
    </div>

    <div data-title="Article 17. Droit de propriété intellectuelle">
      <div class="text-h5 mb-2">Article 17. Droit de propriété intellectuelle</div>
      <p class="text-decoration-underline">17.1 Le Site et son Contenu </p>
      <p>La Société est titulaire ou cessionnaire de l’ensemble des droits de propriété intellectuelle sur les marques,
        logos, graphismes, photographies, animations, vidéos et textes, logiciels et Bases de données contenus sur le
        Site. </p>
      <p>L’Utilisateur s’interdit notamment de modifier, copier, reproduire, télécharger, diffuser, extraire,
        transmettre, exploiter commercialement et/ou distribuer de quelque façon que ce soit les pages du Site, les
        Services proposés par l’intermédiaire du Site, ou les codes informatiques des éléments composant le Site et les
        Services.</p>
      <p>Les droits d’utilisation concédés à l’Utilisateur sont strictement limités à l’accès, à l’affichage, à
        l’impression, à la reproduction sur tous supports et à l’utilisation des résultats des Services, dans les
        conditions définies ci-après. Toute autre utilisation par l’Utilisateur est interdite sans autorisation expresse
        de la Société.</p>
      <p>Il est formellement interdit à l’Utilisateur d’analyser, de visualiser ou de modifier la configuration du Site,
        ainsi que sa structure et les fichiers la constituant, ou tenter de le faire, de même que de copier, traduire,
        modifier, corriger, améliorer, adapter, décompiler par ingénierie inverse ou créer des œuvres dérivées à partir
        du Site.</p>
      <p>L’Utilisateur s’interdit également tout déverrouillage des codes de protection des logiciels ou des Bases de
        données du Site ou de décryptage des clés d’accès, lorsque ces logiciels ou Bases de données sont munis d’un
        système d’accès ou de protection. </p>
      <p>S'agissant des sites Internet et contenus de tiers vers lesquels l’Utilisateur peut être renvoyé, il appartient
        à ce dernier de prendre connaissances des conditions juridiques applicables à ces sites et contenus tiers.</p>
      <p class="text-decoration-underline">17.2 Utilisation des Services</p>
      <p>La Société déclare disposer de l’intégralité des droits de propriété intellectuelle sur les Services proposés
        par l’intermédiaire du Site et de l’outil Check Position.</p>
      <p>L’ensemble des éléments relatifs au fonctionnement des Services (notamment logiciels, codes sources,
        applications, …) restent la propriété exclusive de la Société. L’Utilisateur n’acquerra sur ces éléments aucun
        droit autre que ceux qui lui sont expressément concédés aux termes des présentes Conditions Générales.</p>
      <p>L’Utilisateur s’engage à ne pas porter atteinte, directement ou indirectement, aux intérêts de la Société,
        qu’ils soient moraux ou patrimoniaux.</p>
      <p>Il s’interdit de mettre les Services accessibles par l’intermédiaire du Site et leur documentation à
        disposition de tiers, directement ou indirectement, à quelque titre, sous quelque forme et pour quelque cause
        que ce soit, en dehors des cas prévus ci-après : </p>
      <ul>
        <li>Dans le cadre de l’Utilisation des Services, l’Utilisateur est uniquement autorisé à procéder à l’extraction
          et la reproduction des résultats affichés par l’intermédiaire du Site à l’issue d’une recherche sur l’outil
          Check Position sur support papier ou informatique, pour un usage exclusivement interne et pour les besoins
          propres de l’Utilisateur ou du Bénéficiaire désigné lors de la recherche, et à la condition de mentionner de
          façon claire et précise la source.
        </li>
        <li>Les recherches et résultats effectués par l’Utilisateur pour le compte d’un Bénéficiaire sont exclusivement
          réservés au Bénéficiaire désigné sur le Site lors de la recherche. L’Utilisateur s’interdit de transmettre à
          un Bénéficiaire une recherche effectuée pour le compte d’un autre Bénéficiaire.
        </li>
      </ul>
      <p>De manière générale et hors du cadre normal d’utilisation décrit ci-dessus, toute extraction et/ou reproduction
        d’une partie qualitativement ou quantitativement substantielle des informations diffusées sur le Site et des
        résultats affichés sur le Site est strictement interdite.</p>
    </div>

    <div data-title="Article 18. Convention de preuve">
      <div class="text-h5 mb-2">Article 18. Convention de preuve</div>
      <p>Les documents sous forme électronique, échangés entre les parties, auront valeur de preuve, sous réserve que
        puisse être dûment identifiée la personne dont ils émanent. </p>
      <p>Les enregistrements informatisés, conservés dans les systèmes informatiques de la Société seront conservés dans
        des conditions raisonnables de sécurité et considérés comme les preuves de l’accès et de l’utilisation du Site
        et des Services. </p>
      <p>La Société pourra se prévaloir comme preuve de tout acte, programmes, Données, fichiers, enregistrements,
        opérations ou autres éléments de nature ou sous format ou support informatique ou électronique, établis, reçus
        ou conservés directement ou indirectement par la Société.</p>
    </div>

    <div data-title="Article 19. Durée du Contrat - Suspension et résiliation">
      <div class="text-h5 mb-2">Article 19. Durée du Contrat - Suspension et résiliation</div>
      <p class="text-decoration-underline">19.1 Durée du Contrat, renouvellement et résiliation anticipée</p>
      <p>Les contrats conclus en application des présentes Conditions Générales sont à durée déterminée.</p>
      <p>Dans le cadre d’une souscription à une formule mensuelle, bien que l’Utilisateur ne soit soumis à aucun
        engagement sur la durée, la formule sera automatiquement reconduite à la fin de chaque période. Lorsque la
        période arrive à échéance, l’Utilisateur sera alors informé de la reconduction automatique du contrat à défaut
        de désinscription de sa part avant l’arrivée du terme.</p>
      <p>Dans le cadre d’un abonnement annuel, l’Utilisateur est engagé sur une période contractuelle irrévocable de 12
        mois. Lorsque que l’abonnement arrive à échéance, l’Utilisateur sera invité à souscrire à nouveau à une
        formule.</p>
      <p>L’Utilisateur devra notifier son intention de résilier le contrat souscrit soit par l’intermédiaire de son
        Compte utilisateur, soit en contactant directement la Société par courrier électronique.</p>
      <p>La résiliation, ou désinscription, pourra intervenir à tout moment mais ne sera <strong>effective qu’à l’issue
        de la période contractuelle de fourniture des Services</strong>, soit mensuellement ou annuellement selon la
        formule souscrite par l’Utilisateur.</p>
      <p class="text-decoration-underline">19.2 Suspension immédiate </p>
      <p>La Société pourra restreindre, limiter ou suspendre, de plein droit et sans formalités, tout ou partie des
        Services en cas de manquement quelconque de l’Utilisateur aux dispositions contractuelles.</p>
      <p>La Société pourra subordonner le rétablissement des Services à la mise en œuvre effective des mesures
        appropriées destinées à garantir tout risque de perpétuation ou de réitération des manquements à l’origine de la
        suspension.</p>
      <p class="text-decoration-underline">19.3 Résiliation pour faute </p>
      <p>En cas de défaut de paiement ou de manquement aux dispositions contractuelles et de non-régularisation par
        l’Utilisateur après suspension de l’accès aux Services, la Société procédera sans formalités à la résiliation du
        contrat après une mise en demeure adressée par voie électronique et/ou lettre recommandée avec accusé de
        réception restée sans effet pendant 15 jours.</p>
      <p>Dès la résiliation, la Société désactivera l’accès du Compte utilisateur ainsi que de l’ensemble des Services
        attachés à ce Compte.</p>
      <p class="text-decoration-underline">19.4 Conséquence de la résiliation</p>
      <p>
        En cas de résiliation du contrat d&#39;abonnement par l&#39;une ou l&#39;autre des parties et pour quelque
        cause que ce soit, y compris dans les cas d&#39;impossibilité d&#39;accès aux Services décrits à
        l&#39;article 8.1 bis, les sommes versées par l&#39;Utilisateur au titre de l&#39;ensemble de la période
        contractuelle en cours resteront alors acquises à la Société sans que cela ne puisse donner
        lieu à aucune obligation de remboursement à l&#39;Utilisateur ni aucune indemnité que ce soit.
      </p>
      <p>
        De façon expresse, sont considérés comme cas de force majeure ou cas fortuit, outre ceux
        habituellement retenus par la jurisprudence des cours et tribunaux français, les grèves
        totales ou partielles, internes ou externes à l&#39;entreprise, lock-out, intempéries, épidémies,
        blocages des moyens de télécommunications, blocages des moyens de transport ou
        d&#39;approvisionnement pour quelque raison que ce soit, tremblements de terre, incendies,
        tempêtes, inondations, dégâts des eaux, restrictions gouvernementales ou légales,
        modification légales ou réglementaires, ainsi que les limitations d&#39;accès, blocages ou
        restrictions imposés par des services externes (Google, Bing, etc.) ou tout autre fournisseur
        de données dont dépendent les Services fournis par la Société.
      </p>
      <p>À l’issue de la résiliation, les Données de l’Utilisateur ne seront plus accessibles à ce dernier et seront
        automatiquement détruites à l’issue d’un délai de 12 mois suivant la date de résiliation. La souscription d’un
        nouvel accès aux Services pendant cette période permettra à l’Utilisateur d’accéder de nouveau à ses
        Données.</p>
    </div>

    <div data-title="Article 20. Force majeure">
      <div class="text-h5 mb-2">Article 20. Force majeure</div>
      <p>Dans un premier temps, les cas de force majeure suspendront l’exécution du Contrat.</p>
      <p>Si les cas de force majeure perdurent pour une durée supérieure à 3 mois, le Contrat sera automatiquement
        résilié.</p>
      <p>De façon expresse, sont considérés comme cas de force majeure ou cas fortuit, outre ceux habituellement retenus
        par la jurisprudence des cours et tribunaux français, les grèves totales ou partielles, internes ou externes à
        l’entreprise, lock-out, intempéries, épidémies, blocages des moyens de télécommunications, blocages des moyens
        de transport ou d’approvisionnement pour quelque raison que ce soit, tremblements de terre, incendies, tempêtes,
        inondations, dégâts des eaux, restrictions gouvernementales ou légales, modification légales ou
        réglementaires.</p>
    </div>

    <div data-title="Article 21. Intégralité du Contrat">
      <div class="text-h5 mb-2">Article 21. Intégralité du Contrat</div>
      <p>Le Contrat, constitué de l’ensemble des documents contractuels, exprime l’intégralité des obligations des
        parties, relativement à son objet. </p>
      <p>Le fait pour l’une des parties de tolérer une situation n’a pas pour effet d’accorder à l’autre partie des
        droits acquis ; une telle tolérance ne peut être interprétée comme une renonciation à faire valoir les droits en
        cause ultérieurement.</p>
      <p>Si une ou plusieurs dispositions des présentes devaient être tenues pour non-valide(s) ou déclarée(s) comme
        telle(s) en application d’une loi, d’un règlement ou à la suite d’une décision définitive d’une juridiction
        compétente, les autres dispositions garderont toute leur force et leur portée. </p>
    </div>

    <div data-title="Article 22. Loi applicable">
      <div class="text-h5 mb-2">Article 22. Loi applicable</div>
      <p>Les présentes Conditions Générales ainsi que les prestations de Services qu’elles régissent sont soumises à la
        loi française. Il en est ainsi pour les règles de fond comme pour les règles de forme, quel que soit le lieu
        d’accès et d’utilisation du Site et des Services associés.</p>
    </div>

    <div data-title="Article 23. Différends">
      <div class="text-h5 mb-2">Article 23. Différends</div>
      <p>En cas de litige survenant à l’occasion des présentes Conditions Générales et des prestations de Services
        qu’elles régissent, tant pour ce qui concerne leur interprétation que leur exécution, et éventuellement après
        une tentative de recherche d’une solution amiable, la compétence exclusive est attribuée aux tribunaux
        compétents de Paris,
        nonobstant la pluralité de défendeurs ou appels en
        garantie, même pour les procédures d’urgence ou les mesures conservatoires, et les mesures d’exécution.</p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'TermsOfService'
}
</script>
